<template>
  <b-card>
    <base-overlay :show="fetchingReward">
      <validation-observer ref="rewardsFormRef">
        <b-form @submit.prevent="submitHandler">
          <b-row>
            <b-col md="4">
              <validation-provider
                name="Name En"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Name En"
                  label-for="name-en"
                >
                  <b-form-input
                    id="name-en"
                    v-model="rewardForm.name.en"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="Name Ar"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Name Ar"
                  label-for="name-ar"
                >
                  <b-form-input
                    id="name-ar"
                    v-model="rewardForm.name.ar"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!enableTiers"
              md="4"
            >
              <b-form-group
                label="Amount"
                label-for="reward-amount"
              >
                <b-form-input
                  id="reward-amount"
                  v-model.number="rewardForm.amount"
                  type="number"
                  :disabled="!isNew"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                name="Effective Date"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Effective Date"
                  label-for="effective-date"
                >
                  <flat-pickr
                    id="effective-date"
                    v-model="rewardForm.effectiveTime"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      minDate: new Date(),
                      allowInvalidPreload: true,
                    }"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="Expiry Date"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Expiry Date"
                  label-for="end-date"
                >
                  <flat-pickr
                    id="end-date"
                    v-model="rewardForm.endTime"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      minDate: new Date(),
                      allowInvalidPreload: true,
                    }"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-if="!enableTiers"
              md="12"
            >
              <b-form-group label="Reward Type">
                <b-form-radio-group
                  v-model="rewardType"
                  :options="[
                    { text: 'Promo Code', value: 'promo' },
                    { text: 'Wallet', value: 'wallet' }
                  ]"
                  buttons
                  button-variant="outline-primary"
                  name="rewardTypeRadios"
                  :disabled="!isNew"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="rewardType === 'promo' && !enableTiers"
              md="3"
            >
              <b-form-group
                label="Group"
                label-for="groups"
              >
                <v-select
                  id="groups"
                  v-model="rewardForm.group"
                  :options="groupsList"
                  :loading="fetchingGroups"
                  label="name"
                  :reduce="val => val.id"
                  :disabled="!isNew"
                  @search="fetchGroups"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="!enableTiers"
              md="3"
            >
              <b-form-group
                label="User Segment"
                label-for="targeted-groups"
              >
                <v-select
                  id="targeted-groups"
                  v-model="rewardForm.targetedGroup"
                  :options="groupsList"
                  :loading="fetchingGroups"
                  label="name"
                  :reduce="val => val.id"
                  :disabled="!isNew"
                  @search="fetchGroups"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="!enableTiers"
              md="3"
            >
              <validation-provider
                name="Number of trips"
                rules="required|max-value:500"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Number of trips"
                  label-for="no-of-trips"
                >
                  <b-form-input
                    id="no-of-trips"
                    v-model.number="rewardForm.criteria.numberOfTrips"
                    type="number"
                    :disabled="!isNew"
                    @input="numberOfTripsInput"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!enableTiers"
              md="3"
            >
              <b-form-group
                label="Pickup Zone"
                label-for="pickup-zone"
              >
                <v-select
                  id="pickup-zone"
                  v-model="rewardForm.criteria.pickupZone"
                  :options="zonesList"
                  :loading="fetchingZones"
                  :disabled="!isNew || fetchingZones"
                  label="name"
                  multiple
                  :reduce="val => val.zone_id"
                />
                <small v-if="!isNew">Selected Zone: {{ rewardForm.criteria.pickupZone[0] }}</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                name="English reward description"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="English reward description"
                  label-for="en-reward-description"
                >
                  <b-form-textarea
                    id="en-reward-description"
                    v-model="rewardForm.description.en"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="Arabic reward description"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Arabic reward description"
                  label-for="ar-reward-description"
                >
                  <b-form-textarea
                    id="ar-reward-description"
                    v-model="rewardForm.description.ar"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-if="!enableTiers"
              md="4"
            >
              <b-form-group
                label="Promo Code"
              >
                <b-form-input
                  v-model="rewardForm.promoCode"
                  :disabled="!isNew"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="!enableTiers"
              md="12"
              class="mb-1"
            >
              <b-form-checkbox
                v-model="sendNotification"
                :disabled="!isNew"
              >
                Send Notification
              </b-form-checkbox>
            </b-col>
            <b-col
              md="12"
              class="mb-1"
            >
              <b-form-checkbox
                v-model="enableTiers"
                :disabled="!isNew"
              >
                Enable Tiers
              </b-form-checkbox>
            </b-col>

            <!-- Tiers Management Section -->
            <template v-if="enableTiers">
              <b-col md="12">
                <hr>
                <h5>Tiers Configuration</h5>
                <p class="text-muted">
                  Configure multiple tiers with different trip requirements and actions.
                </p>
              </b-col>

              <b-col
                v-for="(tier, index) in tiers"
                :key="index"
                md="12"
                class="mb-3"
              >
                <b-card class="tier-card">
                  <template #header>
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="mb-0 mr-2">
                        Tier {{ index + 1 }}
                      </h6>
                      <b-button
                        v-if="tiers.length > 1"
                        variant="outline-danger"
                        size="sm"
                        :disabled="!isNew"
                        @click="removeTier(index)"
                      >
                        Remove
                      </b-button>
                    </div>
                  </template>

                  <b-row>
                    <b-col md="3">
                      <validation-provider
                        :name="`Tier ${index + 1} Number of trips`"
                        rules="required"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          label="Number of trips"
                          :label-for="`tier-trips-${index}`"
                        >
                          <b-form-input
                            :id="`tier-trips-${index}`"
                            v-model.number="tier.numberOfTrips"
                            type="number"
                            :disabled="!isNew"
                            min="1"
                            max="500"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col md="6">
                      <validation-provider
                        :name="`Tier ${index + 1} Actions`"
                        rules="required"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          label="Actions"
                          :label-for="`tier-actions-${index}`"
                        >
                          <b-form-checkbox-group
                            :id="`tier-actions-${index}`"
                            v-model="tier.actions"
                            :options="[
                              { text: 'Add to Group', value: 'ADD_TO_GROUP' },
                              { text: 'Credit to Wallet', value: 'CREDIT_TO_WALLET' },
                              { text: 'Send Notification', value: 'SEND_NOTIFICATION' }
                            ]"
                            :disabled="!isNew"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <!-- Group field - shown only when ADD_TO_GROUP is selected -->
                    <b-col
                      v-if="tier.actions.includes('ADD_TO_GROUP')"
                      md="3"
                    >
                      <validation-provider
                        :name="`Tier ${index + 1} Group`"
                        rules="required"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          label="Group"
                          :label-for="`tier-group-${index}`"
                        >
                          <v-select
                            :id="`tier-group-${index}`"
                            v-model="tier.group"
                            :options="groupsList"
                            :loading="fetchingGroups"
                            label="name"
                            :reduce="val => val.id"
                            :disabled="!isNew"
                            @search="fetchGroups"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <!-- Amount field - shown only when CREDIT_TO_WALLET is selected -->
                    <b-col
                      v-if="tier.actions.includes('CREDIT_TO_WALLET')"
                      md="3"
                    >
                      <validation-provider
                        :name="`Tier ${index + 1} Amount`"
                        rules="required"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          label="Amount"
                          :label-for="`tier-amount-${index}`"
                        >
                          <b-form-input
                            :id="`tier-amount-${index}`"
                            v-model.number="tier.amount"
                            type="number"
                            :disabled="!isNew"
                            min="0"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <!-- Notification fields - shown only when SEND_NOTIFICATION is selected -->
                    <template v-if="tier.actions.includes('SEND_NOTIFICATION')">
                      <b-col md="6">
                        <validation-provider
                          :name="`Tier ${index + 1} English notification title`"
                          rules="required"
                        >
                          <b-form-group
                            slot-scope="{ errors }"
                            label="English notification title"
                            :label-for="`tier-en-title-${index}`"
                          >
                            <b-form-input
                              :id="`tier-en-title-${index}`"
                              v-model="tier.notification.title.en"
                              :disabled="!isNew"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="6">
                        <validation-provider
                          :name="`Tier ${index + 1} Arabic notification title`"
                          rules="required"
                        >
                          <b-form-group
                            slot-scope="{ errors }"
                            label="Arabic notification title"
                            :label-for="`tier-ar-title-${index}`"
                          >
                            <b-form-input
                              :id="`tier-ar-title-${index}`"
                              v-model="tier.notification.title.ar"
                              :disabled="!isNew"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="6">
                        <validation-provider
                          :name="`Tier ${index + 1} English notification description`"
                          rules="required"
                        >
                          <b-form-group
                            slot-scope="{ errors }"
                            label="English notification description"
                            :label-for="`tier-en-description-${index}`"
                          >
                            <b-form-textarea
                              :id="`tier-en-description-${index}`"
                              v-model="tier.notification.description.en"
                              :disabled="!isNew"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="6">
                        <validation-provider
                          :name="`Tier ${index + 1} Arabic notification description`"
                          rules="required"
                        >
                          <b-form-group
                            slot-scope="{ errors }"
                            label="Arabic notification description"
                            :label-for="`tier-ar-description-${index}`"
                          >
                            <b-form-textarea
                              :id="`tier-ar-description-${index}`"
                              v-model="tier.notification.description.ar"
                              :disabled="!isNew"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </template>
                  </b-row>
                </b-card>
              </b-col>

              <b-col
                md="12"
                class="mb-3"
              >
                <b-button
                  variant="outline-primary"
                  :disabled="!isNew"
                  @click="addTier"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-1"
                  />
                  Add Tier
                </b-button>
              </b-col>

              <b-col md="12">
                <hr>
              </b-col>
            </template>

            <template v-if="sendNotification && !enableTiers">
              <b-col md="6">
                <validation-provider
                  name="English notification title"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="English notification title"
                    label-for="en-title"
                  >
                    <b-form-input
                      id="en-title"
                      v-model="rewardForm.notification.title.en"
                      :disabled="!isNew"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Arabic notification title"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Arabic notification title"
                    label-for="ar-title"
                  >
                    <b-form-input
                      id="ar-title"
                      v-model="rewardForm.notification.title.ar"
                      :disabled="!isNew"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="English notification description"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="English notification description"
                    label-for="en-description"
                  >
                    <b-form-textarea
                      id="en-description"
                      v-model="rewardForm.notification.description.en"
                      :disabled="!isNew"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Arabic notification description"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Arabic notification description"
                    label-for="ar-description"
                  >
                    <b-form-textarea
                      id="ar-description"
                      v-model="rewardForm.notification.description.ar"
                      :disabled="!isNew"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </template>
            <b-col
              v-if="recurringType != 'custom'"
              md="12"
              class="mb-1"
            >
              <b-form-checkbox
                v-model="rewardForm.criteria.recurring"
                :disabled="!isNew"
              >
                Recurring
              </b-form-checkbox>
            </b-col>
            <b-col
              md="12"
              class="mb-1 d-flex"
              :style="{ gap: '1rem' }"
            >
              <b-form-radio-group
                v-model="recurringType"
                :options="[
                  { text: 'Daily', value: 'daily' },
                  { text: 'Weekly', value: 'weekly' },
                  { text: 'Monthly', value: 'monthly' },
                  { text: 'Custom', value: 'custom' }
                ]"
                buttons
                button-variant="outline-primary"
                name="frequencyRadios"
                :disabled="!isNew"
              />
            </b-col>
            <b-col
              v-if="recurringType == 'daily'"
              :md="6"
            >
              <validation-provider
                name="From hour"
                :rules="`${recurringType == 'daily' ? 'required|between:0,23' : ''}`"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From hour"
                  label-for="from"
                >
                  <b-form-input
                    id="from"
                    v-model.number="rewardForm.criteria.fromHour"
                    type="number"
                    :disabled="!isNew"
                  />
                  <b-form-text>24 hour format, 0 to 23</b-form-text>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="recurringType == 'daily'"
              :md="6"
            >
              <validation-provider
                name="To Hour"
                :rules="`${recurringType == 'daily' ? 'required|between:0,24' : ''}`"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To hour"
                  label-for="to"
                >
                  <b-form-input
                    id="to"
                    v-model.number="rewardForm.criteria.toHour"
                    type="number"
                    :disabled="!isNew"
                  />
                  <b-form-text>24 hour format, 0 to 24</b-form-text>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="recurringType == 'weekly'"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="Week Start Day"
                :rules="`${recurringType == 'weekly' ? 'required' : ''}`"
              >
                <b-form-group
                  label="Week Start Day"
                  label-for="week-start-day"
                >
                  <b-form-select
                    id="week-start-day"
                    v-model="rewardForm.criteria.weekStartDay"
                    placeholder="Week Start Day"
                    :options="fromWeekDays"
                    :disabled="!isNew"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="recurringType == 'weekly'"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="Week End Day"
                :rules="`${recurringType == 'weekly' ? 'required' : ''}`"
              >
                <b-form-group
                  label="Week End Day"
                  label-for="week-end-day"
                >
                  <b-form-select
                    id="week-end-day"
                    v-model="rewardForm.criteria.weekEndDay"
                    placeholder="Week End Day"
                    :options="toWeekDays"
                    :disabled="!isNew"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="recurringType == 'monthly'"
              :md="6"
            >
              <validation-provider
                name="From"
                :rules="`${recurringType == 'monthly' ? 'required|between:0,31' : ''}`"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From"
                  label-for="from"
                >
                  <b-form-input
                    id="from"
                    v-model.number="rewardForm.criteria.monthStartDate"
                    type="number"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="recurringType == 'monthly'"
              :md="6"
            >
              <validation-provider
                name="To"
                :rules="`${recurringType == 'monthly' ? 'required|between:0,31' : ''}`"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To"
                  label-for="to"
                >
                  <b-form-input
                    id="to"
                    v-model.number="rewardForm.criteria.monthEndDate"
                    type="number"
                    :disabled="!isNew"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <template v-if="recurringType == 'custom'">
              <b-col md="6">
                <validation-provider
                  name="From Date"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="From Date"
                    label-for="from-date"
                  >
                    <flat-pickr
                      id="from-date"
                      v-model="rewardForm.criteria.fromDate"
                      class="form-control"
                      :config="{
                        enableTime: true,
                        minDate: new Date(),
                        allowInvalidPreload: true,
                      }"
                      :disabled="!isNew"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="To Date"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="To Date"
                    label-for="to-date"
                  >
                    <flat-pickr
                      id="to-date"
                      v-model="rewardForm.criteria.toDate"
                      class="form-control"
                      :config="{
                        enableTime: true,
                        minDate: new Date(),
                        allowInvalidPreload: true,
                      }"
                      :disabled="!isNew"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </template>
          </b-row>
          <!-- Remove Save button when isNew is false -->
          <b-button
            v-if="isNew"
            variant="primary"
            type="submit"
            :disabled="submitting"
          >
            <b-spinner
              v-if="submitting"
              small
            />
            <span v-else>Submit</span>
          </b-button>
        </b-form>
      </validation-observer>
    </base-overlay>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import {
  BForm, BRow, BCol,
  BCard, BFormGroup, BFormInput,
  BFormTextarea, BFormText, BButton, BSpinner,
  BFormRadioGroup,
  BFormSelect,
  BFormCheckbox,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import useChallengeForm from '../hooks/useChallengeForm'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '@/views/marketing/rewards/store'
import groupsStore from '@/views/marketing/groups/store'
import zonesStore from '@/views/zones/zoneStoreModule'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BForm,
    BFormSelect,
    BRow,
    flatPickr,
    BCol,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCard,
    ValidationObserver,
    BButton,
    vSelect,
    ValidationProvider,
    BFormGroup,
    BFormText,
    BFormRadioGroup,
    BSpinner,
    BFormInput,
    BFormTextarea,
    FeatherIcon,
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('rewards', store)
    useRegisterStoreModule('groups', groupsStore)
    useRegisterStoreModule('zones', zonesStore)

    return {
      ...useChallengeForm(props, ctx),
      required,
    }
  },
}
</script>

<style>

</style>
